import { MarketingClientConstants } from "../constants/marketing-client-constants";
import { DOMHelper } from "../helpers/dom-helper";
import { Utils } from "./utils";

export class Checkbox {
    input: HTMLInputElement | null;
    text: HTMLElement | null;
    checkmark: HTMLElement | null;
    error: HTMLElement | null;

    constructor(id: string) {
        this.input = DOMHelper.getElementById(id) as HTMLInputElement;
        this.text = DOMHelper.querySelector(`#${id}-text`) as HTMLElement;
        this.checkmark = DOMHelper.querySelector(`#${id} + span`) as HTMLElement;
        this.error = DOMHelper.querySelector(`#${id}-error`) as HTMLElement;
    }

    setText(text: string) {
        if (this.text) {
            this.text.innerHTML = text;
        }
    }

    isValidate(): boolean {
        return !!this.input?.checked;
    }

    toggle(): void {
        if (this.isValidate()) {
            this.hideError();
        } else {
            this.showError();
        }
    }

    showError(): void {
        Utils.showContainer(this.error);
        this.checkmark?.classList.add(MarketingClientConstants.hasErrorClassName);
    }

    hideError(): void {
        Utils.hideContainer(this.error);
        this.checkmark?.classList.remove(MarketingClientConstants.hasErrorClassName);
    }

    reset(): void {
        this.hideError();
        if (this.input) {
            this.input.checked = false
        }
    }
}